// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_ybO","cls2":"CitingSourcesCard-cls2_Ez6 CitingSourcesCard-cls1_ybO"};